import React from "react";
import SvgIcon from "../../../parts/SvgIcon";
import { withTranslation } from "react-i18next";

class ExerciseLibraryItemSecondaryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsible: false,
      show: false,
    };
    this.showOptions = this.showOptions.bind(this);
    this.hideOptions = this.hideOptions.bind(this);
    this.togglePressCollapsible = this.togglePressCollapsible.bind(this);
  }

  getLink() {
    const type = this.props.primaryItem ? "primary" : this.props.primary;
    switch (type) {
      case "assistant":
        return `/actions/refresh?modal[type]=add-other-exercise&modal[primary]=${this.props.primary}&modal[index]=${this.props.i}`;
      case "primary":
        return `/actions/refresh?modal[type]=edit-primary-movement&modal[primary]=${this.props.primary}`;
      default:
        return `/actions/refresh?modal[type]=add-secondary-movement&modal[primary]=${this.props.primary}&modal[index]=${this.props.i}`;
    }
  }

  togglePressCollapsible() {
    this.setState({ collapsible: !this.state.collapsible });
  }

  showOptions() {
    this.setState({ show: true });
  }

  hideOptions() {
    this.setState({ show: false });
  }

  render() {
    const { primary, secondary, repMax, i, athlete, query, t } = this.props;
    const { show } = this.state;
    return (
      <div className={`item ${show && "active"}`}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            className={`details ${
              primary === "assistant" && "no-text-details"
            }`}
          >
            {secondary.movement}
          </div>

          <div
            className={`options ${
              primary === "assistant" && "no-text-options"
            }`}
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div className="flex items-center gap-2">
              {primary !== "assistant" && (
                <div className=" font-bold">1RM {repMax}</div>
              )}
              <a
                role="button"
                data-button-type="outline"
                className="z-0"
                href={this.getLink()}
              >
                <span>{t("common:edit")}</span>
              </a>
              {!this.props.primaryItem && (
                <a
                  href={`/actions/user/remove-secondary/${primary}/${i}${
                    athlete ? `?forAthlete=${query.athlete}` : ""
                  }`}
                  role="button"
                  data-button-type="secondary"
                  data-icon
                  data-icon-only
                >
                  <SvgIcon
                    alt={t("common:remove")}
                    src="/img/new-icons/red-trash.svg"
                    noFilterOnLight
                  />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation(["dashboard", "common"])(
  ExerciseLibraryItemSecondaryComponent
);
